export const getDeeplinkWithBacklink = (deeplink: string, backLink: string): string => {
    return `${deeplink}${backLink || ""}`;
};
